module.exports = __webpack_public_path__ + "img/诃子.05044ebe.jpg";